export default {"src":"/_next/static/media/polygon.07a09998.svg","height":238,"width":238,"blurWidth":0,"blurHeight":0};